export default "__VITE_ASSET__BdYVM3lm__"